// @/shared/components/FeatureSlot/index.tsx
import React from "react";
import { Quote } from "@/shared/types/Quote.interface";
import { COMPONENT_REGISTRY } from "./registry";
import { useFeatures } from "@/shared/hooks/useFeatures";

interface FeatureSlotProps {
    stepId: string;
    slotId: string;
    formId: string;
    quote?: Quote;
    className?: string;
}

export const FeatureSlot: React.FC<FeatureSlotProps> = ({ stepId, slotId, formId, quote, className }) => {
    const { getStepComponents, getComponentMetadata } = useFeatures({
        formId,
        quote
    });

    const components = getStepComponents(stepId).filter(c => c.slotId === slotId);

    if (!components.length) {
        return null;
    }

    return (
        <div className={className}>
            {components.map(componentConfig => {
                const Component = COMPONENT_REGISTRY[componentConfig.id];

                if (!Component) {
                    console.warn(`FeatureSlot: Unknown component "${componentConfig.id}"`);
                    return null;
                }

                // Get component-specific metadata
                const componentMetadata = getComponentMetadata(stepId, componentConfig.id);

                return (
                    <Component
                        key={componentConfig.id}
                        componentId={componentConfig.id}
                        stepId={stepId}
                        metadata={componentMetadata} // Component-specific metadata
                        quote={quote}
                        componentConfig={componentConfig} // Pass full config for access to schemaId/destination
                    />
                );
            })}
        </div>
    );
};
